var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{staticClass:"content-area-layout"},[_c('v-flex',{attrs:{"x12":""}},[_c('elevation-profile',{attrs:{"points":_vm.points}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }